import ObjectModelRelation from "./objectModelRelation";
import ObjectModelEntry from "../objectModelEntries/objectModelEntry";
import Guid from "~/helpers/guid";
import BuilderModel from "~/models/tracked/builderModel";
import User from "~/models/user";
import {AccountType} from "~/enums/accountType";

export default class AccountRelation extends BuilderModel {
  client_id: string;
  published_relation_id: string;
  entry_id: string;
  account_id: string;
  account_type: AccountType;
  user_email: string;
  email_sent_at: string;
  claimed_at: string;
  claimed_by_name: string;

  constructor(parent, nameInParent, json={}) {
    super()
    this.client_id = json['client_id']|| Guid.create();
    this.published_relation_id =  json["published_relation_id"];
    this.entry_id = json["entry_id"];
    this.account_id = json["account_id"];
    this.account_type = json["account_type"];
    this.user_email = json["user_email"];
  }

  get relation(): ObjectModelRelation {
    return ObjectModelRelation.repo.find(this.published_relation_id);
  }

  get entry(): ObjectModelEntry {
    return ObjectModelEntry.repo.find(this.entry_id);
  }

  get user() {
    return User.repo.find(this.account_id);
  }

  get json(): any {
    return {
      client_id: this.client_id,
      published_relation: this.published_relation_id,
      entry: this.entry_id,
      account: this.account_id,
      account_type: this.account_type,
    }
  }
}

